<template>
	<div
		class="field field--datepicker"
		:class="{
			'is-readonly': readonly
		}"
	>
		<label v-if="$slots.default" :for="name" class="field__label">
			<slot />
		</label>

		<div class="field__controls">
			<!--
				@vuepic/vue-datepicker replaces vue2-datepicker, which is Vue 2 only.
				Prop names differ: it is v-model based, formats through
				`model-type`, and the calendar icon is the `input-icon` slot.
				The behaviour kept here is the same: a date-only picker, not
				clearable, formatted as the API expects, honouring disableFn.
			-->
			<date-picker
				:ui="{ input: 'field__input' }"
				model-type="yyyy-MM-dd"
				format="yyyy-MM-dd"
				:model-value="modelValue"
				:placeholder="placeholder"
				:disabled-dates="disableFn"
				:disabled="readonly"
				:clearable="false"
				:enable-time-picker="false"
				auto-apply
				@update:model-value="handleChange"
			>
				<template #input-icon>
					<Icon name="calendar" color="currentColor" />
				</template>
			</date-picker>
		</div> <!-- /.field__controls -->
	</div> <!-- /.field -->
</template>

<script>
/**
 * External Dependencies
 */
import DatePicker from '@vuepic/vue-datepicker';

/**
 * Internal Dependencies
 */

import Icon from '@/components/icon/icon';

export default {
	name: 'FormDatepicker',

	components: {
		Icon,
		DatePicker
	},

	props: {
		readonly: {
			type: Boolean,
			default: false
		},
		error: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		tabindex: {
			type: Number,
			default: 0
		},
		disableFn: {
			type: Function
		}
	},

	data: function() {
		return {
			isOpened: false,
		};
	},

	methods: {
		handleChange(val) {
			this.$emit('update:modelValue', val);
		}
	}
};
</script>
